import { FormattedMessage } from 'react-intl'
import { target } from 'utils'
import {
  IncludedDiving,
  PriceConverter,
  PromotionLabel,
  TwoDatesFormat,
} from '../helpers'
import { ShopSlider } from '../search'

export default function ResortDealsCard({
  shop,
  lastMinuteDeals,
  handleClick,
}) {
  const onClick = () => {
    if(handleClick) {
      handleClick(shop)
    }
  }
  return (
    <div className='operator-item-wrapper' key={shop.url} onClick={onClick}>
      <a
        className='operator-item-card bordered-element'
        href={shop.url}
        target={target}
      >
        {lastMinuteDeals ? (
          <ShopSlider slug={shop.shopSlug} />
        ) : (
          <div className='img-wrapper'>
            <span className='label-corner'>
              <span className='label-text'>{shop.percentage}</span>
              <span className='details'>
                <FormattedMessage id='details' defaultMessage='Details' />
              </span>
              <div className='description-promo'>
                <p>{shop.title}</p>
                <div dangerouslySetInnerHTML={{ __html: shop.description }} />
              </div>
              <span className='close-btn-corner'>X</span>
            </span>
            <span
              style={{
                backgroundImage: `url(${shop.backgrounds.DOSliderMobileLand})`,
              }}
              className='img'
            />
            {shop.title && (
              <p className='promo-title'>
                {shop.title.length > 50
                  ? `${shop.title.slice(0, 47)}...`
                  : shop.title}
              </p>
            )}
            <div className='overlay-bottom' />
          </div>
        )}

        <div className='info'>
          <strong className='shop-title'>{shop.shopTitle}</strong>
          <ul className='features'>
            <li>
              <i className='font-icons location-icon' />
              {shop.countryTitle}
            </li>
            <IncludedDiving
              numberOfDivesMax={shop.numberOfDivesMax}
              numberOfDivesMin={shop.numberOfDivesMin}
            />
            <li>
              <i className='font-icons calendar-icon' />
              <TwoDatesFormat dateFrom={shop.dateFrom} dateTo={shop.dateTo} />
            </li>
          </ul>
        </div>
        <div className='price-wrap'>
          <PromotionLabel
            currency={shop.currency}
            price={shop.price}
            compareAtPrice={shop.compareAtPrice}
            showComparePrice
          />
          <span className='price'>
            <PriceConverter amount={shop.price} currency={shop.currency} />
          </span>
          <div className='price-details'>
            <span className='price-type'>
              <FormattedMessage
                id='for_2_divers'
                defaultMessage='for 2 divers in 1 room'
              />
            </span>
          </div>
          <div className='price-details'>
            <span className='price-type'>
              <FormattedMessage
                id='for_nights_qty'
                values={{ qty: shop.nights || shop.duration }}
                defaultMessage='for {qty, plural, one {# night} other {# nights}}'
              />
            </span>
          </div>
        </div>
      </a>
    </div>
  )
}
